export default function PHP_get_html_translation_table() {
  return (
    <div>
      <h1>PHP_get_html_translation_table</h1>
    </div>
  );
}
